/**
 * Gravity Forms multifile: Plupload only covers the browse button with the hidden input.
 * Forward activation on the rest of .gform_drop_area to the real select-files button.
 * touchend + preventDefault is needed so mobile keeps a user gesture for the file picker; click alone is unreliable there.
 */
let strlGfFileuploadSuppressClickUntil = 0;

function strlGfFileuploadGetBrowseForwardTarget(event) {
	const drop = event.target.closest('.gform_wrapper.gravity-theme .gform_drop_area');
	if (!drop) {
		return null;
	}
	const btn = drop.querySelector('.gform_button_select_files');
	if (!btn) {
		return null;
	}
	if (btn === event.target || btn.contains(event.target)) {
		return null;
	}
	if (event.target.closest('.moxie-shim-html5')) {
		return null;
	}
	return btn;
}

function strlGfFileuploadDropzoneOnClick(event) {
	if (Date.now() < strlGfFileuploadSuppressClickUntil) {
		return;
	}
	const btn = strlGfFileuploadGetBrowseForwardTarget(event);
	if (!btn) {
		return;
	}
	btn.click();
}

function strlGfFileuploadDropzoneOnTouchend(event) {
	const btn = strlGfFileuploadGetBrowseForwardTarget(event);
	if (!btn) {
		return;
	}
	strlGfFileuploadSuppressClickUntil = Date.now() + 600;
	event.preventDefault();
	btn.click();
}

document.addEventListener('click', strlGfFileuploadDropzoneOnClick);
document.addEventListener('touchend', strlGfFileuploadDropzoneOnTouchend, { passive: false });
